import type { DemoKey } from '../types';

export const sw: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Hisabati · Takwimu',
  'app.title': 'Takwimu',
  'panel.experiment': 'Tukio',
  'panel.params': 'Vipimo',

  'exp.survey-explorer.title': 'Mtafutaji wa utafiti',
  'exp.survey-explorer.desc': 'Chagua safu; demo huchagua muhtasari sahihi.',
  'exp.distribution-sculptor.title': 'Mchongaji wa mgawanyo',
  'exp.distribution-sculptor.desc': 'Vuta nukta na tazama jinsi takwimu zinavyojibu.',
  'exp.two-variable-lab.title': 'Maabara ya vigezo viwili',
  'exp.two-variable-lab.desc': 'Mtawanyo, ulinganishaji, na swali la sababu.',
  'exp.sampling-lab.title': 'Maabara ya sampuli',
  'exp.sampling-lab.desc': 'Jinsi mbinu na ukubwa zinavyobadilisha wastani wa sampuli.',
  'exp.probability-diagrams.title': 'Michoro ya uwezekano',
  'exp.probability-diagrams.desc': 'Maoni ya Venn na mti kwa matukio jumuishi.',

  'type.qualitative-nominal.label': 'Kifio · jina',
  'type.qualitative-nominal.def': 'Aina zisizo na mpangilio wa kawaida.',
  'type.qualitative-ordinal.label': 'Kifio · mpangilio',
  'type.qualitative-ordinal.def': 'Aina zenye mpangilio wa maana.',
  'type.qualitative-multi.label': 'Kifio · thamani nyingi',
  'type.qualitative-multi.def': 'Kila uchunguzi unaweza kuwa na lebo nyingi.',
  'type.quantitative-discrete.label': 'Kiasi · kifusi',
  'type.quantitative-discrete.def': 'Nambari katika hatua zilizofungwa.',
  'type.quantitative-continuous.label': 'Kiasi · endelevu',
  'type.quantitative-continuous.def': 'Nambari zilizopimwa katika kipimo endelevu.',

  'column.name.label': 'Jina la mwanafunzi',
  'column.height_cm.label': 'Urefu',
  'column.shoe_size_eu.label': 'Saizi ya kiatu (EU)',
  'column.study_hours.label': 'Saa za kusoma / wiki',
  'column.test_score.label': 'Alama ya mtihani',
  'column.sports_played.label': 'Michezo iliyochezwa',
  'column.eye_color.label': 'Rangi ya jicho',
  'column.commute_min.label': 'Safari',
  'column.grade_year.label': 'Darasa',
  'column.homework_effort.label': 'Bidii ya kazi ya nyumbani',
  'column.ice-cream-sales.label': 'Mauzo ya barafu',
  'column.drownings.label': 'Kuzama',
  'column.month.label': 'Mwezi',
  'column.storks.label': 'Korongo',
  'column.births.label': 'Vizazi',
  'column.country_area_km2.label': 'Eneo la nchi',
  'column.sleep_hours.label': 'Saa za kulala',
  'column.reaction_ms.label': 'Muda wa kuitikia',

  'dataset.master-survey.label': 'Utafiti wa darasa',
  'dataset.master-survey.desc': 'Wanafunzi 30 walioigwa.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Mauzo ya barafu dhidi ya kuzama',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Yote yanapanda na kushuka na msimu. Kuzama hakusababishi mauzo ya barafu.',
  'dataset.spurious-storks-vs-births.label': 'Korongo dhidi ya vizazi',
  'dataset.spurious-storks-vs-births.desc':
    'Nchi kubwa zina korongo zaidi na vizazi zaidi. Ndege siyo chanzo.',
  'dataset.real-sleep-vs-reaction-time.label': 'Usingizi dhidi ya muda wa kuitikia',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Usingizi zaidi, kuitikia haraka zaidi. Uhusiano hasi wa kweli — na utaratibu unaowezekana.',

  'tag.football.label': 'Mpira wa miguu',
  'tag.basketball.label': 'Mpira wa kikapu',
  'tag.volleyball.label': 'Mpira wa wavu',
  'tag.swimming.label': 'Kuogelea',
  'tag.none.label': 'Hakuna',

  'population.gaussian.label': 'Mvinje wa kengele',
  'population.right-skewed.label': 'Kupinda kulia',
  'population.bimodal.label': 'Vilele viwili',
  'population.uniform.label': 'Sawa',

  'venn.dice-even-or-prime.label': 'Dadu: shufwa au msingi',
  'venn.class-sports-2set.label': 'Michezo (seti 2)',
  'venn.class-sports-3set.label': 'Michezo (seti 3)',
  'venn.custom.label': 'Kawaida',

  'tree.draw-without-replacement.label': 'Toa bila kurudisha',
  'tree.custom.label': 'Kawaida',
  'tree.coin.heads': 'K',
  'tree.coin.tails': 'P',
  'tree.draw.start': 'Mfuko: 2 nyekundu, 3 bluu',
  'tree.draw.red': 'Nyekundu',
  'tree.draw.blue': 'Bluu',
  'tree.custom.start': 'Anza',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogramu',
  'card.cumulative': 'Mzunguko jumuishi',
  'card.box': 'Sanduku',
  'card.summary': 'Muhtasari wa nambari 5',
  'card.bar': 'Chati ya pao',
  'card.mode': 'Mode',
  'card.tag-frequency': 'Mzunguko wa lebo',
  'card.mode-tag': 'Lebo kuu',
  'card.empty-no-order': 'Haitumiki',
  'card.empty-multi': 'Haitumiki',
  'card.numberline': 'Mstari wa nambari',
  'card.scatter': 'Mtawanyo',
  'card.description': 'Kinachoendelea',
  'card.population': 'Idadi',
  'card.sampling-distribution': 'Wastani wa sampuli',
  'card.venn': 'Venn',
  'card.tree': 'Mti',
  'card.probabilities': 'Uwezekano',

  'param.dataset.label': 'Seti ya data',
  'param.column.label': 'Safu',
  'param.bins.label': 'Vipande',
  'param.shape.label': 'Umbo la awali',
  'param.show-mean.label': 'Onyesha wastani',
  'param.show-median.label': 'Onyesha kati',
  'param.x-col.label': 'Safu X',
  'param.y-col.label': 'Safu Y',
  'param.show-regression.label': 'Mstari wa kurudi',
  'param.show-residuals.label': 'Mabaki',
  'param.show-confounder.label': 'Onyesha mchanganyiko',
  'param.population.label': 'Idadi',
  'param.technique.label': 'Mbinu',
  'param.sample-size.label': 'Ukubwa wa sampuli',
  'param.stratum.label': 'Tabaka',
  'param.bias.label': 'Upendeleo',
  'param.mode.label': 'Modi',
  'param.preset.label': 'Iliyowekwa',
  'param.universe.label': 'Ukubwa wa ulimwengu',
  'param.show-prob.label': 'Onyesha uwezekano',
  'param.treat-as-numeric.label': 'Tibu kama nambari',

  'stat.count': 'Idadi',
  'stat.mean': 'Wastani',
  'stat.median': 'Kati',
  'stat.range': 'Anuwai',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Vya nje',
  'stat.r': 'r ya Pearson',
  'stat.r2': 'r²',
  'stat.slope': 'Mteremko',
  'stat.intercept': 'Kushikana',
  'stat.n': 'n',
  'stat.population-mean': 'Wastani halisi',
  'stat.latest-sample-mean': 'Wastani wa sampuli',
  'stat.sample-mean-spread': 'SD wastani wa sampuli',
  'stat.sample-count': 'Sampuli zilizochukuliwa',
  'outlier.upper': 'Vya nje vya juu',
  'outlier.lower': 'Vya nje vya chini',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Chukua tena',
  'btn.run-100': 'Chukua sampuli 100',
  'btn.stop': 'Simama',
  'btn.clear-history': 'Futa historia',

  'explainer.no-order': 'Hakuna mpangilio → hakuna jumuishi, hakuna sanduku.',
  'explainer.multi-no-iqr': 'Thamani nyingi → robo / IQR hazitafsiriki.',
  'message.no-data': 'Hakuna data.',
  'message.needs-quartiles': 'Inahitaji ≥4 nukta kwa robo.',
  'message.x-zero-variance': 'Mtawanyo wa X ni sifuri — hakuna mstari.',
  'message.n-too-small': 'n ni ndogo sana.',
  'message.stratum-clamp': 'Tabaka lilikuwa na safu chache zaidi — zote zilitumika.',
  'message.siblings-sum-to-one': 'Watoto lazima wajumuike kuwa 1.',
};
